import { Chains } from '../chains';
import { ContractsConfig, DepositsConfigs, RedisConfig } from './config.interface';

export const baseContractsConfig: ContractsConfig = {
  usdt: '0x2A1e0E339355899f5F7f7c1F4590a79D6B49D4F2',
  phnm: '0xE24D8d07AC6c54Ff358b00c1Bc5dB4A6f73a42cb',
  tables: '0xd841DaCe0EfdD174526daDBaA38f3358144bbe91',
  revenueShareManager: '0xbf1728a34920F42B51F02b4B7dd869704b560d7a',
  rakeManager: '0x0d275F8498BC75c10F6aAB54CD3dD3f4439C51AA',
  redemptionManager: '0xD6Bb3F4576f341Bbc8DbC9d0a302205C643783a8',
  redemptionVault: '0x0cACa68A160b2c43C248C1E2b045c3e09C2E02c2',
  rewardsManager: '0x4FCF496238D13696f1aaF384Dc5dbe9871f449F4',
  safeTreasury: '0xc4BB12CFde0DC6F2Bb4e0bF83325Cf20878aD1BE',
  orchestrator: '0xfD02a9Ee216dB49D2a80F98339F0402a297dFB31',
  redemption: '0xe28C4129828e8a0900e3AD01BB9419e13815aA15',
  smartWallet: '0x8310a1bBB27f29935008BDc8BAc970d86B329d0a',
  poolAccount: '0x0000000000000000000000000000000000000000',
  leaderboard: '0x8a2bfd90EeD3027014b8AAc0A1555aDd3773D0BF',
  tournaments: '0x538b27C6b9Bd4fF55Ae5F7f9E590034E1b6d1D38',
  tournamentFactory: '0xA5F975205d3b7686235A251416692c19749A7f35',
  backendDeployer: '0x3814F5029f09D197e9DCFc23f01Fbe4de3503F41',
  fireblocksTreasury: '0xcD2D535ea34F0e8cF8BeF90819933117f366b50e',
  ticket: '0x389cf803849C353A853BF1bD405277403d84d85f',
  tournamentRakeManager: '0xb6Fba6a199Fe59A5d42872b3eA86398A1476cD5b',
};

const redisConfig: RedisConfig = {
  keys: {
    pendingTransactions: 'pending:transactions',
    userWallets: 'user_wallets',
  },
};

const depositsConfig: DepositsConfigs = {
  [Chains.ETHEREUM]: {
    name: 'Ethereum',
    nativeToken: 'ETH',
    supportedTokens: {
      USDT: '0xdAC17F958D2ee523a2206206994597C13D831ec7',
      USDC: '0xA0b86991c6218b36c1d19D4a2e9Eb0cE3606eB48',
      DAI: '0x6B175474E89094C44Da98b954EedeAC495271d0F',
      ETH: '0x00',
      BNB: '0xB8c77482e45F1F44dE1745F52C74426C631bDD52',
      WETH: '0xC02aaA39b223FE8D0A0e5C4F27eAD9083C756Cc2',
      WBTC: '0x2260FAC5E5542a773Aa44fBCfeDf7C193bc2C599',
      UNI: '0x1f9840a85d5aF5bf1D1762F925BDADdC4201F984',
    },
    fees: 1.5,
    minimumFee: 2,
    blockExplorerUrl: 'https://etherscan.io/',
  },
  [Chains.OPTIMISM]: {
    name: 'Optimism',
    nativeToken: 'OP',
    supportedTokens: {
      OP: '0x00',
    },
    fees: 1,
    minimumFee: 0.5,
    blockExplorerUrl: 'https://optimistic.etherscan.io/',
  },
  [Chains.BSC]: {
    name: 'BSC',
    nativeToken: 'BNB',
    supportedTokens: {
      USDC: '0x8AC76a51cc950d9822D68b83fE1Ad97B32Cd580d',
      WBNB: '0xbb4CdB9CBd36B01bD1cBaEBF2De08d9173bc095c',
      BNB: '0x00',
    },
    fees: 1,
    minimumFee: 0.5,
    blockExplorerUrl: 'https://bscscan.com/',
  },
  [Chains.POLYGON]: {
    name: 'Polygon',
    nativeToken: 'POL',
    supportedTokens: {
      USDT: '0xc2132D05D31c914a87C6611C10748AEb04B58e8F',
      USDC: '0x3c499c542cEF5E3811e1192ce70d8cC03d5c3359',
      USDCe: '0x2791Bca1f2de4661ED88A30C99A7a9449Aa84174',
      DAI: '0x8f3Cf7ad23Cd3CaDbD9735AFf958023239c6A063',
      WETH: '0x7ceB23fD6bC0adD59E62ac25578270cFf1b9f619',
      POL: '0x00',
    },
    fees: 1,
    minimumFee: 0.5,
    blockExplorerUrl: 'https://polygonscan.com/',
  },
  [Chains.ARBITRUM]: {
    name: 'Arbitrum',
    nativeToken: 'ARB',
    supportedTokens: {
      USDC: '0xaf88d065e77c8cC2239327C5EDb3A432268e5831',
      ARB: '0x00',
    },
    fees: 1,
    minimumFee: 0.5,
    blockExplorerUrl: 'https://arbiscan.io/',
  },
  [Chains.AVALANCHE]: {
    name: 'Avalanche',
    nativeToken: 'AVAX',
    supportedTokens: {
      AVAX: '0x00',
      USDTe: '0xc7198437980c041c805A1EDcbA50c1Ce5db95118',
      USDT: '0x9702230A8Ea53601f5cD2dc00fDBc13d4dF4A8c7',
      USDC: '0xB97EF9Ef8734C71904D8002F8b6Bc66Dd9c48a6E',
    },
    fees: 1,
    minimumFee: 0.5,
    blockExplorerUrl: 'https://avascan.info/blockchain/c/',
  },
  [Chains.SOLANA]: {
    name: 'Solana',
    nativeToken: 'SOL',
    supportedTokens: {
      SOL: '0x00',
      JUP: 'JUPyiwrYJFskUPiHa7hkeR8VUtAeFoSYbKedZNsDvCN',
    },
    fees: 1,
    minimumFee: 0.5,
    blockExplorerUrl: 'https://solscan.io/',
  },
  [Chains.LITECOIN]: {
    name: 'Litecoin',
    nativeToken: 'LTC',
    supportedTokens: {
      LTC: '0x00',
    },
    fees: 1,
    minimumFee: 0.5,
    blockExplorerUrl: 'https://litecoinspace.org/',
  },
  [Chains.BITCOINCASH]: {
    name: 'Bitcoin Cash',
    nativeToken: 'BCH',
    supportedTokens: {
      BCH: '0x00',
    },
    fees: 1,
    minimumFee: 0.5,
    blockExplorerUrl: 'https://explorer.bitcoinunlimited.info/',
  },
  [Chains.TRON]: {
    name: 'Tron',
    nativeToken: 'TRX',
    supportedTokens: {
      USDT: 'TR7NHqjeKQxGTCi8q8ZY4pL8otSzgjLj6t',
    },
    fees: 1.5,
    minimumFee: 3,
    blockExplorerUrl: 'https://tronscan.org/#/transaction/',
  },
  [Chains.BITCOIN]: {
    name: 'Bitcoin',
    nativeToken: 'BTC',
    supportedTokens: {
      BTC: '0x00',
    },
    fees: 1.5,
    minimumFee: 2,
    blockExplorerUrl: 'https://btcscan.org/',
  },
};

export const baseConfig: {
  contracts: ContractsConfig;
  redis: RedisConfig;
  deposits: DepositsConfigs;
} = {
  contracts: baseContractsConfig,
  redis: redisConfig,
  deposits: depositsConfig,
};
